/** What ats-project stores as a nationwide project's location (`projectLocationFor`). */
export const NATIONWIDE_PROJECT_LOCATION = 'USA';
export const NATIONWIDE_PROJECT_LOCATION_LABEL = 'Nationwide (U.S.)';

// Stringified empties from a job whose city and state were both nulled.
const PLACEHOLDER_PARTS = new Set(['', 'null', 'undefined']);

/**
 * The location line of a project card. A nationwide job has no city of its own and its
 * project stores the country, so it reads as nationwide instead of a bare "USA" or the
 * "null, null" an older event handler wrote; an empty location stays empty.
 */
export function formatProjectLocation(location: string | null | undefined): string {
  const raw = (location ?? '').trim();
  if (raw === '') return '';

  const parts = raw
    .split(',')
    .map((part) => part.trim())
    .filter((part) => !PLACEHOLDER_PARTS.has(part.toLowerCase()));

  if (parts.length === 0) return NATIONWIDE_PROJECT_LOCATION_LABEL;
  if (parts.length === 1 && parts[0].toUpperCase() === NATIONWIDE_PROJECT_LOCATION) {
    return NATIONWIDE_PROJECT_LOCATION_LABEL;
  }
  return raw;
}
